import React, { ReactNode } from 'react';
import cx from 'classnames';

export interface TitleProps {
  className?: string;
  label?: ReactNode;
}

export function Title({ label, className }: TitleProps) {
  return (
    <span
      className={cx(className, 'text-[28px] font-bold v2-text-neutral-900')}
    >
      {label}
    </span>
  );
}
